import React from 'react';
import PropTypes from 'prop-types';
import FooterLogo from './footerLogo';
import FooterContent from './footerContent';
import './styles.less';

const Footer = (props) => {
    const {footerData} = props;

    return (
        <footer className="global-navigation-footer">
            <div className="global-navigation-footer-container">
                <div className="global-navigation-footer-inner-container">
                    <FooterLogo
                        url={footerData.vrboLogo.content[0].url}
                        imgSrc={footerData.vrboLogo.content[0].imgSrc}
                    />
                    <FooterContent
                        content={[
                            footerData.exploreVrbo,
                            footerData.company,
                            footerData.meetTheVrboFamily,
                        ]}
                    />
                    <div className="footer-content-divider-container">
                        <hr className="footer-content-divider" />
                    </div>
                    <ul className="footer-copyright-outer-container">
                        <li
                            className="footer-copyright-inner-container"
                            role="listitem"
                        >
                            <div className="footer-copyright">
                                <span className="footer-copyright-text">
                                    {footerData.tradeMark.content[0].text}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    footerData: PropTypes.shape({
        vrboLogo: PropTypes.shape({
            content: PropTypes.arrayOf(
                PropTypes.shape({
                    url: PropTypes.string,
                    imgSrc: PropTypes.string,
                })
            ),
        }),
        exploreVrbo: PropTypes.shape({
            title: PropTypes.string,
            content: PropTypes.array,
        }),
        company: PropTypes.shape({
            title: PropTypes.string,
            content: PropTypes.array,
        }),
        meetTheVrboFamily: PropTypes.shape({
            title: PropTypes.string,
            content: PropTypes.array,
        }),
        tradeMark: PropTypes.shape({
            content: PropTypes.arrayOf(
                PropTypes.shape({
                    text: PropTypes.string,
                })
            ),
        }),
    }).isRequired,
};

export default Footer;
